import { render, staticRenderFns } from "./ViewToggler.vue?vue&type=template&id=5262a1f5"
import script from "./ViewToggler.vue?vue&type=script&lang=js"
export * from "./ViewToggler.vue?vue&type=script&lang=js"
import style0 from "./ViewToggler.vue?vue&type=style&index=0&id=5262a1f5&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports